<template>
	<!-- Modal -->
	<div class="modal fade" id="alertModalWizard" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="addingAlert !== null">
<!--		  <template v-if="this.bindAlert">{{reRender()}}</template>-->
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLabel"> {{ this.alertModalTitle }}</h5>
					<button type="button" class="btn-close" id="close-modal" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<form class="popup-form" @submit.prevent="nextStep">


					<div class="modal-body" v-if="!this.loading && warehouses">
						<div class="row">
              <WizardTabs
                  :tabs="tabs"
                  :active-tab="activeTab"
                  @change-tab="changeTab"
              />

							<div class="tab-content">

									<Tab1 :active-tab="activeTab"/>
                  <Tab2/>
								<div id="tab3" v-if="activeTab === 3" class="row">
									<div class="col-md-12">
										<h4 class="text-center">განგაშს თან ახლდეს</h4>
										<div class="col-md-6 col-sm-12 col-xs-12  row d-flex justify-content-center align-items-center">
											<div class="col-6 form-check">
												<input class="form-check-input" v-model="this.alertSound" type="checkbox" value=""
															 id="sound-signal">
												<label class="form-check-label" for="sound-signal">
													ხმოვანი სიგნალი
												</label>
											</div>
											<div class="col-6 form-check">
												<input class="form-check-input" type="checkbox" value="" v-model="this.alertPopup"
															 id="popup-window">
												<label class="form-check-label" for="popup-window">
													Popup ფანჯარა
												</label>
											</div>
										</div>
									</div>


									<div class="col-md-6 col-sm-12 p-t-20">
										<h6 class="text-left">SMS</h6>

										<div class="input-group mb-3">

											<button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
															aria-expanded="false">
												{{ numberExtension(0) }}
											</button>
											<ul class="dropdown-menu">
												<li><a class="dropdown-item" href="#" @click.prevent="changeNumberExt(0, '+995')">+995</a></li>
												<li><a class="dropdown-item" href="#" @click.prevent="changeNumberExt(0,'+374')">+374</a></li>
											</ul>


											<input type="text" class="form-control" v-model="phoneNumbers[0]"
														 placeholder="შეიყვანეთ ნომერი"
														 aria-label="Text input with dropdown button">
										</div>
										<div class="input-group mb-3">
											<button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
															aria-expanded="false">
												{{ numberExtension(1) }}
											</button>
											<ul class="dropdown-menu">
												<li><a class="dropdown-item" href="#" @click.prevent="changeNumberExt(1, '+995')">+995</a></li>
												<li><a class="dropdown-item" href="#" @click.prevent="changeNumberExt(1,'+374')">+374</a></li>
											</ul>
											<input type="text" class="form-control" v-model="phoneNumbers[1]"
														 placeholder="შეიყვანეთ ნომერი"
														 aria-label="Text input with dropdown button">
										</div>
										<div class="input-group mb-3">
											<button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
															aria-expanded="false">
												{{ numberExtension(2) }}
											</button>
											<ul class="dropdown-menu">
												<li><a class="dropdown-item" href="#" @click.prevent="changeNumberExt(2, '+995')">+995</a></li>
												<li><a class="dropdown-item" href="#" @click.prevent="changeNumberExt(2,'+374')">+374</a></li>
											</ul>
											<input type="text" class="form-control" v-model="phoneNumbers[2]"
														 placeholder="შეიყვანეთ ნომერი"
														 aria-label="Text input with dropdown button">
										</div>
									</div>

									<div class="col-md-6 col-sm-12 p-t-20 ">
										<h6 class="text-left">Mail</h6>

										<div class="input-group mb-3">
                    <span class="input-group-text exclude-this " id="basic-addon3">
                      <img src="/svgs/email.svg">
                    </span>
											<input type="text" id="email-address" name="emailAddresses" v-model="emails[0]"
														 placeholder="შეიყვანეთ ელ.ფოსტა"
														 class="form-control"/>
											<span class="input-group-text exclude-this" id="eye-addon">
                      <img src="/svgs/add-contact.svg">
                    </span>
										</div>

										<div class="input-group mb-3">
                  <span class="input-group-text exclude-this" id="basic-addon3">
                   <img src="/svgs/email.svg">
                  </span>
											<input type="text" id="email-address" name="emailAddresses"
														 placeholder="შეიყვანეთ ელ.ფოსტა"
														 v-model="emails[1]" class="form-control"/>
											<span class="input-group-text exclude-this" id="eye-addon">
                    <img src="/svgs/add-contact.svg">
                  </span>
										</div>

										<div class="input-group mb-3">
                  <span class="input-group-text exclude-this" id="basic-addon3">
                   <img src="/svgs/email.svg">
                  </span>
											<input type="text" id="email-address" name="emailAddresses"
														 placeholder="შეიყვანეთ ელ.ფოსტა"
														 v-model="emails[2]" class="form-control"/>
											<span class="input-group-text exclude-this" id="eye-addon">
                    <img src="/svgs/add-contact.svg">
                  </span>
										</div>

									</div>

								</div>

								<div id="tab4" :class="activeTab === 4 ? 'row active-tab' : 'row hidden-tab' ">
									<template v-for="i in weeksArray.length" :key="i">
										<div class="extra-week-area row col-12">
											<div class="col-md-5 col-sm-12 no-p-r">
                        <div class="input-group addon-filter">
                          <v-select v-model="timeRangeStart[i - 1]" class="addon-select-extra" label="name"
                                    id="interval-name-start" :options="filteredStartOptions[i - 1]"
                                    :class="{ 'invalid-week': invalidAlertTimes.some(item => item.type === 'start' && item.index === i) }"
                                    @update:modelValue="removeInvalidEntry('start', i)"
                          >
                            <template v-slot:no-options>სია ცარიელია</template>
                          </v-select>
                          <span class="input-group-text no-padding px-3">
                  <img :src="'/svgs/clock.svg'">
                </span>
                          <v-select v-model="timeRangeEnd[i - 1]" class="addon-select-extra second-extra"
                                    label="name" id="interval-name-end" :options="filteredEndOptions[i - 1]"
                                    :class="{ 'invalid-week': invalidAlertTimes.some(item => item.type === 'end' && item.index === i) }"
                                    @update:modelValue="removeInvalidEntry('end', i)"
                          >
                            <template v-slot:no-options>სია ცარიელია</template>
                          </v-select>
                        </div>
											</div>
											<div class="col-md-7 col-sm-12 week-col d-flex align-items-center gap-2 justify-content-start">
                        <div class="input-group week-groups" :class="{ 'invalid-week': v$.weeksArray.$error && invalidWeeks.includes(i) }">
                  <span :class="'input-group-text ' + isSelectedWeek(1,i - 1,true)" id="basic-addon3"
												@click="selectWeek(1,i - 1)">
                    ორ
                  </span>
													<span :class="'input-group-text ' + isSelectedWeek(2,i - 1,true)" @click="selectWeek(2,i - 1)"
																id="basic-addon4">
                    სმ
                  </span>
													<span :class="'input-group-text ' + isSelectedWeek(3,i - 1,true)" @click="selectWeek(3,i - 1)"
																id="basic-addon5">
                    ოთხ
                  </span>
													<span :class="'input-group-text ' + isSelectedWeek(4,i - 1,true)" @click="selectWeek(4,i - 1)"
																id="basic-addon6">
                    ხთ
                  </span>
													<span :class="'input-group-text ' + isSelectedWeek(5,i - 1,true)" @click="selectWeek(5,i - 1)"
																id="basic-addong7">
                    პრ
                  </span>
													<span :class="'input-group-text ' + isSelectedWeek(6,i - 1,true)" @click="selectWeek(6,i - 1)"
																id="basic-addon8">
                    შბ
                  </span>
													<span :class="'input-group-text basic-addon9 ' + isSelectedWeek(7,i - 1,true)"
																@click="selectWeek(7,i - 1)">
                    კვ
                  </span>
												</div>
                        <div class="d-flex gap-1">
                                             <span v-if="i === weeksArray.length" class="cursor-pointer week-plus d-flex justify-content-center align-items-center"
                                                   @click="plusWeekContent">
                    <img src="/svgs/add2.svg" alt="">
                  </span>
                          <span v-if="i === weeksArray.length && weeksArray.length !== 1" class="cursor-pointer week-plus d-flex justify-content-center align-items-center"
                                @click="minusWeekContent()">
                      <img src="/svgs/delete.svg" alt="">
                  </span>
                        </div>
											</div>
										</div>
									</template>

								</div>

								<div id="tab5" :class="activeTab === 5 ? 'row active-tab' : 'row hidden-tab' ">
									<div class="col-12">
										<label for="employees" class="form-label">მომხმარებელი </label>
										<v-select v-model="selectedEmployee" label="nickname" id="employees" multiple=""
															placeholder="აირჩიეთ მომხმარებელი"
															:options="employees"
                              :class="{'select-is-invalid': v$.selectedEmployee.$error}"
                    >
											<template v-slot:no-options>სია ცარიელია</template>
										</v-select>
                    <div class="invalid-feedback" v-if="v$.selectedEmployee.$error">
                      {{ v$.selectedEmployee.$errors[0]?.$message }}
                    </div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="modal-footer">
						<button class="btn btn-brand" @click.prevent="previousStep">უკან</button>
						<button class="btn btn-primary">{{ submitBtnTxt }}</button>
					</div>

				</form>

			</div>
		</div>
	</div>

</template>

<script>

import {ref} from "vue";
import {helpers, required, requiredIf} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import decbin from "decbin";
import Tab1 from "@/components/alert/tabs/Tab1.vue";
import KSelect from "@/components/custom/KSelect";
import WizardTabs from "@/components/alert/partials/WizardTabs/WizardTabs.vue";
import Tab2 from "@/components/alert/tabs/Tab2.vue";

export default {
	name: 'AddAlertPopup',
	components: {Tab2, WizardTabs, KSelect, Tab1},
	props: ['addingAlert', 'bindAlert'],
	computed: {
    filteredStartOptions() {
      return this.timeRangeEnd.map((end, index) => {
        return end
            ? this.timeArray.filter(time => time < end)
            : this.timeArray;
      });
    },
    filteredEndOptions() {
      return this.timeRangeStart.map((start, index) => {
        return start
            ? this.timeArray.filter(time => time > start)
            : this.timeArray;
      });
    },
		warehouses() {

      if (this.$store.state.warehouse?.list.data?.list && [11,28].includes(this.alertType))

        this.$store.state.warehouse.list.data.list = this.$store.state.warehouse.list.data.list.filter(item => item.id !== -1)

        this.$store.state.warehouse.list.data.list = [{name: "ყველა", id: -1, imei: "empty", index: -1}, ...this.$store.state.warehouse.list.data.list]

			return this.$store.state.warehouse.list.data
		},
		rooms() {
			if (this.$store.state.warehouse.rooms.data) {
				return this.$store.state.warehouse.rooms.data.list
			}
			return []
		},
		sensors() {
			if (this.$store.state.warehouse.sensors.sensors) {
				let ars = [{name: "ყველა", id: -1, imei: "empty", index: -1}, ...this.$store.state.warehouse.sensors.sensors]
				return ars
			}
			return [{name: "ყველა", id: -1, imei: "empty", index: -1}]
		},
		employees() {
			if (this.$store.state.reports.employees.data) {
				return this.$store.state.reports.employees.data.employees
			}
			return []
		},
		alertTypes() {
			let alertTypes = [];
			this.$store.state.alert.alertTypes.forEach((type) => {
				alertTypes.push({label: this.$t('alr_' + type.name), value: type.id});
			})
			return alertTypes
		},
	},
	methods: {
    removeInvalidEntry(type, index) {
      this.invalidAlertTimes = this.invalidAlertTimes.filter(
          item => !(item.type === type && item.index === index)
      );
    },
    hasEmptyTimeRange() {
      this.invalidAlertTimes = []
      this.timeRangeStart.forEach((start, index) => {
        if (!start) {
          this.invalidAlertTimes.push({type: "start", index: index + 1})
        }
      });

      this.timeRangeEnd.forEach((end, index) => {
        if (!end) {
          this.invalidAlertTimes.push({type: "end", index: index + 1})
        }
      });

      return this.invalidAlertTimes.length > 0
    },
		changeNumberExt(elementIndex, ext) {
			this.numberExtensions[elementIndex] = ext
		},
    hasEmptyWeeks() {
      this.invalidWeeks = []
      this.weeksArray.forEach((week, index) => {
        if (Array.isArray(week) && week.filter(item => item !== null).length === 0) {
          this.invalidWeeks.push(index + 1)
        }
      });

      return this.invalidWeeks.length > 0;
    },
		numberExtension(elementIndex) {
			if (!this.numberExtensions[elementIndex]) {
				this.numberExtensions[elementIndex] = "+995"
			}
			return this.numberExtensions[elementIndex]
		},
		  plusWeekContent() {
      this.v$.weeksArray.$reset();
      this.timeRangeStart.push('00:00')
      this.timeRangeEnd.push('24:00')
      this.weeksArray.push([])
		},
		minusWeekContent(index) {
			if (this.weeksArray[index]) {
				delete this.weeksArray[index]
			}
      this.weeksArray.pop();
      this.timeRangeStart.pop();
      this.timeRangeEnd.pop();
		},
		async changeTab(tabIndex) {
      // What to validate in each step
      const fields = {
        1: ['alertName', 'alertType', 'alertValues.lowerLimit', 'alertValues.limit', 'alertValues.time', 'alertValues.lossTime'],
        2: ['warehouse', 'selectedRoom', 'selectedSensor'],
        3: [''],
        4: ['weeksArray', 'timeRange'],
        5: ['selectedEmployee']
      };

      
      if (this.warehouse?.id == -1 ) {
        fields[2] = ['warehouse', 'selectedSensors']
      }

      // Flatten the nested validation structure to access the `$invalid` property
      const invalidFields = fields[this.activeTab].filter(field => {
        const path = field.split('.');
        let validation = this.v$;
        for (const key of path) {
          validation = validation[key];
          if (!validation) return false; // If the path is invalid, skip this field
        }
        return validation.$invalid;
      });

      if (invalidFields.length > 0) {
        this.invalidTab.push(this.activeTab);
        // Trigger the `$touch` method for each invalid field
        invalidFields.forEach(field => {
          const path = field.split('.');
          let validation = this.v$;
          for (const key of path) {
            validation = validation[key];
            if (!validation) return; // If the path is invalid, skip this field
          }
          validation.$touch();
        });
        return;
      }
      this.invalidTab = this.invalidTab.filter(tab => tab !== this.activeTab);

			if (tabIndex === 6) {
				this.saveAlert()
			}

			if (tabIndex <= 5 && tabIndex >= 1) {
				this.activeTab = tabIndex
			}

			if (this.activeTab === 5) {
				this.submitBtnTxt = "დამატება"
			} else {
				this.submitBtnTxt = "შემდეგი"
			}

		},
		isActiveTabClasses(index) {
			return this.activeTab >= index ? 'wizard-img-container active' : 'wizard-img-container'
		},
		isActiveTab(index) {
			return this.activeTab >= index
		},
		selectWeek(week, rootIndex = 0) {
      this.invalidWeeks = this.invalidWeeks.filter(invalidWeek => invalidWeek !== rootIndex + 1)
			if (!this.weeksArray[rootIndex]) {
				this.weeksArray[rootIndex] = []
			}
			this.weeksArray[rootIndex][week] ? delete this.weeksArray[rootIndex][week] : this.weeksArray[rootIndex][week] = week

		},
		isSelectedWeek(weekIndex, rootIndex = 0) {
			if (!this.weeksArray[rootIndex]) {
				return ''
			}

			return this.weeksArray[rootIndex][weekIndex] ? 'active-week' : '';
		},
		onChangeWarehouse(element) {
			this.$store.dispatch('warehouse/getWarehouseRooms', element.id).then(
					() => {
						this.sensors = null
					}
			)
		},
		onChangeRooms(element) {
			this.$store.dispatch('warehouse/getWarehouseRoomSensors', element.id).then(
					() => {
					}
			)
		},
    nextStep() {
      this.changeTab(this.activeTab + 1);
    },
		previousStep() {
			this.changeTab(this.activeTab - 1)
		},
    checkBindEdit(clear = false) {
      if (!clear && this.bindAlert !== null) {
        let alert = this.bindAlert.data.alert
        let sensorData = this.bindAlert.data.sensor
        this.alertId = alert.id
        this.alertName = alert.name
        this.alertType = alert.alert_type.id
        this.alertValues.lowerLimit = alert.value1
        this.alertValues.limit = alert.value2
        this.alertValues.time = alert.value3
        this.alertValues[3] = alert.value4
        this.alertPopup = alert.popup
        this.alertSound = alert.sound
        this.emails = alert.emails.map(function (item) {
          return item.email
        })
        this.numberExtensions = alert.phones.map(function (item) {
          return item.telephon.substring(0, 4)
        })
        this.phoneNumbers = alert.phones.map(function (item) {
          return item.telephon.substring(4, item.telephon.length)
        })
        if ([11, 28].includes(alert.alert_type.id)) {

          if(alert.alldevices){
            this.warehouse = {name: 'ყველა', id: -1}
            this.selectedRoom = {name: 'ყველა', id: -1}
            this.selectedSensors = alert.value5.split(',').map(el => {
              return {
                name: Number(el) + 1,
                index: Number(el) + 1
              }
            })
          } else {
            this.warehouse = sensorData.room_to_sensor.room.warehouse
            this.selectedRoom = sensorData.room_to_sensor.room
            this.selectedSensor = alert.value5 !== '-1' ? sensorData : {name: 'ყველა', imei: alert.device.imei}
          }

        }
        if (alert.alert_type.id === 31) {
          this.warehouse = alert.value2 !== '-1' ? sensorData.room_to_sensor.room.warehouse : sensorData.warehouse
          this.selectedRoom = alert.value2 !== '-1' ? sensorData.room_to_sensor.room : sensorData.warehouse.warehouse_rooms[0]
          this.selectedSensor = alert.value2 !== '-1' ? sensorData : {name: 'ყველა', imei: alert.device.imei}
        }
        if (alert.alertstypeid === 15) {
          this.warehouse = sensorData.room_to_sensor.room.warehouse
          this.selectedRoom = sensorData.room_to_sensor.room
          this.selectedSensor = {name: 'ყველა', imei: alert.device.imei}
        }
        this.selectedEmployee = alert.users.map(function (item) {
          item.nickname = item.username
          return item
        })

        this.workingWeekCount = alert.time.length === 0 ? 0 : alert.time.length - 1

        this.timeRangeStart = alert.time.map(function (item) {
          return item.timefrom.substring(0, item.timefrom.length - 3)
        })
        this.timeRangeEnd = alert.time.map(function (item) {
          return item.timeto.substring(0, item.timeto.length - 3)
        })

        for (let i = 0; i < alert.time.length; i++) {
          //reverse binary
          let decs = [...decbin(alert.time[i].weekdays)].reverse().join("")

          if (!this.weeksArray[i]) {
            this.weeksArray.push([])
          }
          this.weeksArray[i][0] = null
          for (let j = 0; j <= decs.length + 1; j++) {
            if (decs[j] === '1') {
              this.weeksArray[i][j + 1] = j + 1
            } else {
              this.weeksArray[i][j + 1] = null
            }
          }
        }

        if (this.selectedSensor && typeof this.selectedSensor.id === "undefined") {
          this.selectedSensor.id = -1
          this.selectedSensor.index = -1
        }
        this.onChangeWarehouse(this.warehouse)
        this.onChangeRooms(this.selectedRoom)

      } else {
        this.alertId = null
        this.alertName = null
        this.alertType = null
        // this.alertLimit = null
        // this.alertTime = null
        this.alertValues = [null, null, null, null, null]
        this.warehouse = null
        this.selectedRoom = null
        this.selectedSensor = null
        this.selectedSensors = []
        this.numberExtensions = []
        this.phoneNumbers = []
        this.alertSound = null
        this.alertPopup = null
        this.emails = []
        this.timeRangeStart = ref(["00:00"])
        this.timeRangeEnd = ref(["24:00"])
        this.weeksArray = [['', 1, 2, 3, 4, 5, 6, 7]]
        this.workingWeekCount = 0
        this.selectedEmployee = ref(null)
        this.submitBtnTxt = 'შემდეგი'
      }
    },
		saveAlert() {
      const temporaryAlertValues = [null, null, null, null, null]
      temporaryAlertValues[0] = this.alertValues.lowerLimit
      temporaryAlertValues[1] = this.alertValues.limit
      temporaryAlertValues[2] = this.alertValues.time

      let imei = null

      if (this.warehouse?.id != -1) {
        imei = this.selectedSensor ? this.selectedSensor.imei : this.sensors[1].imei
      }

			let data = {
				'id': this.alertId,
				'alert_name': this.alertName,
				'alert_type': this.alertType,
				'alert_values': temporaryAlertValues,
				'alert_device': 'devicxe',
				'alert_sensor': this.selectedSensor ? this.selectedSensor.id : null,
				'alert_sensors': this.selectedSensors ? this.selectedSensors : [],
				'smsType': 'standard',
				'mailType': 'standard',
				'imei': imei,
				'employers': this.selectedEmployee.map(function (item) {
					return item.nickname
				}),
				'weekdays': this.weeksArray,
				'alert_date_from': this.timeRangeStart,
				'alert_date_end': this.timeRangeEnd,
				'alert_phones': [this.numberExtensions, this.phoneNumbers],
				'alert_emails': this.emails,
				'index': this.selectedSensor ? this.selectedSensor.index : null,
				'alert_sound': this.alertSound,
				'alert_popup': this.alertPopup,
				'warehouse': this.warehouse.id
			}

			this.$store.dispatch('alert/saveAlert', data).then(
					() => {
						document.getElementById('close-modal').click()
            this.submitBtnTxt = "შემდეგი"
            this.activeTab = 1;
					}
			)
			this.$store.dispatch('alert/getAlerts').then(
					() => this.loading = false
			)
		}
	},
	setup() {
		return {v$: useVuelidate()}
	},
	data() {
		const timeArray = [
			'00:00', '01:00', '02:00', '03:00',
			'04:00', '05:00', '06:00', '07:00',
			'08:00', '09:00', '10:00', '11:00',
			'12:00', '13:00', '14:00', '15:00',
			'16:00', '17:00', '18:00', '19:00',
			'20:00', '21:00', '22:00', '23:00',
			'24:00',
		]

		return {
			activeTab: 1,
      invalidTab: [],
      invalidWeeks: [],
      invalidAlertTimes: [],
      tabs: [
        { id: 1, label: 'კონფიგურაცია', icon: '/svgs/settings.svg', activeIcon: '/svgs/settings.svg' },
        { id: 2, label: 'მოწყობილობა', icon: '/svgs/devices.svg', activeIcon: '/svgs/devices-active.svg' },
        { id: 3, label: 'შეტყობინებები', icon: '/svgs/notification.svg', activeIcon: '/svgs/notification-active.svg' },
        { id: 4, label: 'განრიგი', icon: '/svgs/note.svg', activeIcon: '/svgs/note-active.svg' },
        { id: 5, label: 'მომხმარებლები', icon: '/svgs/profile.svg', activeIcon: '/svgs/profile-active.svg' },
      ],
			alertId: ref(null),
			alertName: ref(null),
			alertType: ref(null),
			// alertLimit: ref(null),
			// alertTime: ref(null),
			alertValues: [null, null, null, null, null],
			warehouse: ref(null),
			selectedRoom: ref(null),
			selectedSensor: ref(null),
			selectedSensors: ref(null),
			numberExtensions: ref([]),
			phoneNumbers: ref([]),
			alertSound: ref(null),
			alertPopup: ref(null),
			emails: ref([]),
			timeArray: timeArray,
			timeRangeStart: ref(["00:00"]),
			timeRangeEnd: ref(["24:00"]),
			weeksArray: [[null, 1, 2, 3, 4, 5, 6, 7]],
			workingWeekCount: 0,
			selectedEmployee: ref(null),
			loading: true,
			submitBtnTxt: 'შემდეგი',
			alertModalTitle: 'განგაშის დამატება'
		}
	},
	mounted() {
    const modalElement = document.getElementById("alertModalWizard");
    modalElement.addEventListener("hidden.bs.modal", () => {
    this.activeTab = 1;
    this.invalidTab = [];
    this.v$.$reset();
    })
		this.$store.dispatch('warehouse/getWarehouseList').then(
				() => {
					this.loading = false
				}
		)
		this.$store.dispatch('reports/getEmployees').then(
				() => {
					this.loading = false
				}
		)
		this.$store.dispatch('alert/getAlertTypes').then(
				() => this.loading = false
		)
	},
	updated() {
		// this.checkBindEdit()
	},

	validations() {
		return {
			warehouse: { required: helpers.withMessage('საწყობი სავალდებულოა', required) },
			selectedRoom: { required: helpers.withMessage('ოთახი სავალდებულოა', required) },
			selectedSensor: {
        required: helpers.withMessage('სენსორი სავალდებულოა',
            requiredIf(() => { return this.alertType !== 15 })
        )
      },
			selectedSensors: {
        validator: helpers.withMessage('სენსორი სავალდებულოა', () => {
          return this.selectedSensors.length > 0;
        })
      },
      alertName: { required: helpers.withMessage('დასახელება სავალდებულოა', required) },
      alertType: { required: helpers.withMessage('განგაშის ტიპი სავალდებულოა', required) },
      alertValues: {
        // LowerLimit = alertValues[0]
        lowerLimit: {
          required: helpers.withMessage('ქვედა ზღვარი სავალდებულოა',
              requiredIf(() => { return this.alertType && [11,28].includes(this.alertType) })
          ),
          validator: helpers.withMessage('ქვედა ზღვარი არ უნდა აღემატებოდეს ზედა ზღვარს', () => {
            if (this.alertType && [11, 28].includes(this.alertType) && this.alertValues.limit !== null && this.alertValues.limit !== '') {
              return Number(this.alertValues.lowerLimit) < Number(this.alertValues.limit);
            }
            return true;
          })
        },
         // Limit = alertValues[1]
        limit: {
          required: helpers.withMessage('ზედა ზღვარი სავალდებულოა',
              requiredIf(() => { return this.alertType && [11,28].includes(this.alertType) })
          )
        },
        // Time = alertValues[2]
        time: {
          required: helpers.withMessage('დაშვებულო დრო სავალდებულოა',
              requiredIf(() => { return this.alertType && [11,28].includes(this.alertType) })
          )
        },
        // LossTime = alertValues[0]
        lossTime: {
          required: helpers.withMessage('დაკარგვის დრო სავალდებულოა',
              requiredIf(() => { return this.alertType && [15,31].includes(this.alertType) })
          )
        }
      },
      weeksArray: {
        validator: helpers.withMessage('ყველა კვირა სავალდებულოა', () => {
          // Call a function that checks if there are any empty weeks

          return !this.hasEmptyWeeks();
        })
      },
      timeRange: {
        validator: helpers.withMessage('ველი სავალდებულოა', () => {
          // Call a function that checks if there are any empty TimeRanges
          return !this.hasEmptyTimeRange();
        })
      },
      selectedEmployee: {
        validator: helpers.withMessage('მომხმარებელი სავალდებულოა', () => {
          return this.selectedEmployee.length > 0;
        })
      }
    }
	}
}
</script>

<style scoped src="./AddAlertPopup.css"></style>